// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nqfU","col":"styles_col__3flNU"};